import {FormControl, FormGroupDirective } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { ErrorStateMode } from '../enums';

export class BmErrorStateMatcher implements ErrorStateMatcher {

  constructor(private mode: ErrorStateMode) {}

  isErrorState(control: FormControl | null, form: FormGroupDirective | null): boolean {

    const submitted = form && form.submitted;
    const formTouched = form && form.submitted && form.touched;
    const touched = control && control.touched;
    const dirty = control && control.dirty;

    switch (this.mode) {
      case ErrorStateMode.OnTouchedForm:
        return formTouched && control.invalid;
      case ErrorStateMode.OnSubmit:
        return submitted && control.invalid;
      case ErrorStateMode.OnTouched:
        return (submitted || touched) && control.invalid;
      case ErrorStateMode.OnDirty:
        return (submitted || dirty) && control.invalid;
    }
  }
}
